import { PreviewBar as PreviewBarInner } from '@bingads-webui-react/notification-preview-bar';
import { withLock, keyVault, priorityLevel } from '@bingads-webui-react/popup-manager';

export const PreviewBar = withLock(PreviewBarInner, {
  lockKey: keyVault.previewBar,
  priority: priorityLevel.previewBar,
});
